var $e16c55913ae3971e$exports = {};
$e16c55913ae3971e$exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


export {$e16c55913ae3971e$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
